import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/gaoxiao', label: '分类' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-9 h-9 rounded-lg bg-[oklch(var(--primary-500))] flex items-center justify-center">
              <i className="ri-vidicon-line text-background-50 text-lg"></i>
            </div>
            <span
              className={`text-xl font-bold transition-colors duration-300 ${
                isScrolled ? 'text-foreground-950' : 'text-foreground-950'
              }`}
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              香蕉视频
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 hover:text-[oklch(var(--primary-500))] ${
                  location.pathname === link.to
                    ? 'text-[oklch(var(--primary-500))]'
                    : 'text-foreground-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Desktop Actions */}
          <div className="hidden md:flex items-center gap-3">
            <button className="w-9 h-9 rounded-full bg-background-100 flex items-center justify-center cursor-pointer hover:bg-background-200 transition-colors">
              <i className="ri-search-line text-foreground-700 text-lg"></i>
            </button>
            <Link
              to="/about"
              className="whitespace-nowrap px-5 py-2 rounded-full bg-[oklch(var(--primary-500))] text-background-50 text-sm font-medium hover:bg-[oklch(var(--primary-500)/0.85)] transition-colors cursor-pointer"
            >
              开始创作
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden w-10 h-10 rounded-full bg-background-100 flex items-center justify-center cursor-pointer hover:bg-background-200 transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i
              className={`text-foreground-700 text-lg ${
                isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'
              }`}
            ></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200 py-4 px-2">
            <div className="flex flex-col gap-2">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`px-4 py-3 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${
                    location.pathname === link.to
                      ? 'bg-[oklch(var(--primary-500)/0.1)] text-[oklch(var(--primary-500))]'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <Link
                to="/about"
                className="mt-2 px-4 py-3 rounded-full bg-[oklch(var(--primary-500))] text-background-50 text-sm font-medium text-center whitespace-nowrap hover:bg-[oklch(var(--primary-500)/0.85)] transition-colors cursor-pointer"
              >
                开始创作
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}